import { Loader, Button } from "@launchmetrics/lm-ui";
import { Card, Form } from "react-bootstrap";
import Breadcrumb from 'components/LM/common/Breadcrumb';
import './orphanmsearch.scss';

function OrphanMSearchForm(props) {
	return (
		<div className="orphan-search-form">
		  <Form>
		  	<Breadcrumb items={['Orphan', 'Mass Search']}/>
			<Card>
			  <Card.Header>
				<Card.Title tag="h5">
				  Enter a list of search terms here, one term per line
				</Card.Title>
				<h6 className="card-subtitle text-muted">
				  Insert the full URL of the profile you want to search (e.g. https://www.instagram.com/launchmetrics)
				</h6>
			  </Card.Header>
			  <Card.Body>
				<Form.Group className="mb-3" controlId="inSearchProfiles">
				  <Form.Control
					as="textarea"
					rows="10"
					disabled={props.processing}
					onChange={(ev) => props.onChange(ev)}
					value={props.query ?? ''}
				  />
				</Form.Group>
				<Button
					color="primary"
					size="small"
					type="submit"
					className="mr-1"
					disabled={props.processing || props.hasError || !props.query || !props.query.length}
					onClick={(ev) => props.onSubmit(ev)}
				  >
					Submit
					{props.processing && <Loader styleProps={{ marginLeft: '10px'}}size={20} />}
				  </Button>
				  <div className="p-2">{props.hasError? <span className="d-flex align-items-center text-danger">⚠️ {props.error}</span> : null}</div>
			  </Card.Body>
			</Card>
		  </Form>
		</div>
	)
}

export default OrphanMSearchForm;
